
export const providers = {
  google: {
    clientId: "142486705727-s2ebg9focq1kjbrrfn7e5jqetje3m3s1.apps.googleusercontent.com",
    redirectUri: process.env.NODE_ENV === 'development'
      ? 'http://localhost:8080/me/auth/callback'
      : 'https://inthefish.com/me/auth/callback'
  },
  facebook: {
    clientId: "",
    redirectUri: process.env.NODE_ENV === 'development'
      ? 'http://localhost:8080/me/auth/callback'
      : 'https://inthefish.com/me/auth/callback'
  }
}

export const api = {
  baseUrl: process.env.NODE_ENV === 'development'
    ? 'http://localhost:8000/api'
    : 'https://inthefish.com/api'
}

